import { Component } from '@angular/core';
import { AlertController, NavParams, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';

/**
 * Component que devuelve un datetime segun lugar (espana - usa)
 *
 */

@Component({
  selector: 'create-delivery',
  templateUrl: 'create-delivery.html',
})
export class CompCreateDeliveryPage {
  update_state: boolean;
  delivery: any = {};
  //
  name: string;
  favourite: boolean;

  constructor(
    public globals: Globals,
    public viewCtrl: ViewController,
    public translate: TranslateService,
    public navParams: NavParams,
    public alertCtrl: AlertController) {
    this.update_state = this.navParams.get('update_state');
    if (this.navParams.get('delivery')) {
      this.delivery = this.navParams.get('delivery');
      this.name = this.delivery.name;
      this.favourite = this.delivery.active;
    }
  }

  close() {
    this.viewCtrl.dismiss(this.delivery);
  }

  update() {
    this.delivery.name = this.name;
    this.delivery.active = this.favourite;
    this.close();
  }

  delete() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('configuracion-eliminar-delivery'),
      message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.delivery.delete = true;
            this.close();
          }
        }
      ]
    });
    alert.present();
  }
}


// WEBPACK FOOTER //
// ./src/pages/components/popups/create-delivery/create-delivery.ts